import Component from '../core/Component'
import EventBus from '../core/EventBus'
import support from '../utils/BrowserSupport'
import { toggleClass } from '../utils/dom'

const defaults = {
    symbol: 'right'
}

export default class Cursor extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            content: null,
            spread: null
        }

        const state = {
            clicked: false,
            active: false,
            visible: false,
            symbol: defaults.symbol
        }

        this.hasMoved = false

        this.state = new Proxy(state, {
            set: (obj, prop, value) => {
                if (obj[prop] !== value) {
                    if (prop === 'symbol') {
                        this.element.classList.remove(`is-${obj[prop]}`)
                        this.element.classList.add(`is-${value}`)
                        obj[prop] = value
                    } else {
                        obj[prop] = value
                        toggleClass(this.element, `is-${prop}`, value)
                    }
                }
                return true
            }
        })
    }

    prepare() {
        this.element.addEventListener(support.transitionEnd, this.handleTransitionEnd)
        window.addEventListener('mousemove', this.handleMouseMove)
        document.addEventListener('click', this.handleClick)
        EventBus.on('cursor:region:enter', this.handleCursorRegionEnter)
        EventBus.on('cursor:region:leave', this.handleCursorRegionLeave)
        EventBus.on('swup:beforecontentchange', this.handleCursorRegionLeave)
    }

    destroy() {
        window.removeEventListener('mousemove', this.handleMouseMove)
        document.removeEventListener('click', this.handleClick)
        EventBus.off('cursor:region:enter', this.handleCursorRegionEnter)
        EventBus.off('cursor:region:leave', this.handleCursorRegionLeave)
        EventBus.off('swup:beforecontentchange', this.handleCursorRegionLeave)
    }

    handleTransitionEnd = event => {
        if (event.target === this.element && !this.state.active) {
            this.state.visible = false
        }

        if (event.target === this.ref.spread && this.state.clicked) {
            this.state.clicked = false
        }

    }

    handleMouseMove = event => {
        this.hasMoved = true
        if (!this.state.visible) {
            return
        }

        this.element.style.top = `${event.clientY}px`
        this.element.style.left = `${event.clientX}px`
    }

    handleCursorRegionEnter = ({ symbol = defaults.symbol }) => {
        if (!this.hasMoved) {
            return
        }

        if (symbol !== this.state.symbol) {
            this.state.symbol = symbol
            this.element.offsetWidth
        }

        if (!this.state.active) {
            this.state.active = true
            this.state.visible = true
        }
    }

    handleCursorRegionLeave = () => {
        if (!this.hasMoved) {
            return
        }

        this.state.active = false
    }

    handleClick = () => {
        if (this.state.visible && !this.state.clicked) {
            this.state.clicked = true
        }
    }
}
